import { useEffect, useRef } from 'react';

interface UseBannerAnimationProps {
  items: any[];
  interval: number;
  isExpanded: boolean;
  isHovered: boolean;
  onIndexChange: (callback: (prevIndex: number) => number) => void;
}

export const useBannerAnimation = ({
  items,
  interval,
  isExpanded,
  isHovered,
  onIndexChange,
}: UseBannerAnimationProps) => {
  const animationFrameRef = useRef<number>();
  const lastUpdateTimeRef = useRef<number>(0);
  const collapseTimeRef = useRef<number>(0);

  useEffect(() => {
    if (!items || items.length < 2) return;

    const animate = (currentTime: number) => {
      if (!lastUpdateTimeRef.current) {
        lastUpdateTimeRef.current = currentTime;
      }

      const elapsed = currentTime - lastUpdateTimeRef.current;
      const timeSinceCollapse = Date.now() - collapseTimeRef.current;

      if (elapsed >= interval && !isExpanded && !isHovered && timeSinceCollapse >= 2000) {
        onIndexChange((prevIndex) => (prevIndex + 1) % items.length);
        lastUpdateTimeRef.current = currentTime;
      }

      animationFrameRef.current = requestAnimationFrame(animate);
    };

    animationFrameRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [items, interval, isExpanded, isHovered, onIndexChange]);

  return {
    collapseTimeRef,
  };
}; 